import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatNotificationService {
  private chatNotifications = new BehaviorSubject<string[]>([]);

  constructor() {
    // Load saved notifications from localStorage
    const savedNotifications = localStorage.getItem('chatNotifications');
    if (savedNotifications) {
      this.chatNotifications.next(JSON.parse(savedNotifications));
    }
  }

  addChatNotification(orderId: string) {
    const currentNotifications = this.chatNotifications.value;
    if (!currentNotifications.includes(orderId)) {
      const newNotifications = [...currentNotifications, orderId];
      this.chatNotifications.next(newNotifications);
      localStorage.setItem('chatNotifications', JSON.stringify(newNotifications));
    }
  }

  clearChatNotification(orderId: string) {
    const currentNotifications = this.chatNotifications.value;
    // console.log(currentNotifications);
    const newNotifications = currentNotifications.filter(id => id !== orderId);
    this.chatNotifications.next(newNotifications);
    localStorage.setItem('chatNotifications', JSON.stringify(newNotifications));
  }

  hasChatNotification(orderId: string): boolean {
    return this.chatNotifications.value.includes(orderId);
  }

  getChatNotifications() {
    return this.chatNotifications.asObservable();
  }
} 